import { tzIntlTimeZoneName as a } from "../../_lib/tzIntlTimeZoneName/index.js";
import { tzParseTimezone as m } from "../../_lib/tzParseTimezone/index.js";
const z = 60 * 1e3, X = {
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, n, s) {
    const e = u(s.timeZone, t);
    if (e === 0)
      return "Z";
    switch (n) {
      case "X":
        return f(e);
      case "XXXX":
      case "XX":
        return r(e);
      case "XXXXX":
      case "XXX":
      default:
        return r(e, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, n, s) {
    const e = u(s.timeZone, t);
    switch (n) {
      case "x":
        return f(e);
      case "xxxx":
      case "xx":
        return r(e);
      case "xxxxx":
      case "xxx":
      default:
        return r(e, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, n, s) {
    const e = u(s.timeZone, t);
    switch (n) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + O(e, ":");
      case "OOOO":
      default:
        return "GMT" + r(e, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, n, s) {
    switch (n) {
      case "z":
      case "zz":
      case "zzz":
        return a("short", t, s);
      case "zzzz":
      default:
        return a("long", t, s);
    }
  }
};
function u(t, n) {
  var e;
  const s = t ? m(t, n, !0) / z : (e = n == null ? void 0 : n.getTimezoneOffset()) != null ? e : 0;
  if (Number.isNaN(s))
    throw new RangeError("Invalid time zone specified: " + t);
  return s;
}
function i(t, n) {
  const s = t < 0 ? "-" : "";
  let e = Math.abs(t).toString();
  for (; e.length < n; )
    e = "0" + e;
  return s + e;
}
function r(t, n = "") {
  const s = t > 0 ? "-" : "+", e = Math.abs(t), o = i(Math.floor(e / 60), 2), c = i(Math.floor(e % 60), 2);
  return s + o + n + c;
}
function f(t, n) {
  return t % 60 === 0 ? (t > 0 ? "-" : "+") + i(Math.abs(t) / 60, 2) : r(t, n);
}
function O(t, n = "") {
  const s = t > 0 ? "-" : "+", e = Math.abs(t), o = Math.floor(e / 60), c = e % 60;
  return c === 0 ? s + String(o) : s + String(o) + n + i(c, 2);
}
export {
  X as formatters
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns-tz@3.2.0_date-fns@3.6.0/~/date-fns-tz/dist/esm/format/formatters/index.js
// module id = 1377
// module chunks = 67